import { useCallback, useEffect, useState, Fragment } from "react";
import { Grid, Button, TextField } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from "@mui/icons-material/Delete";
import Upload from "components/shared/Upload";
import BackButton from "components/shared/BackButton";
import {
  StyledStack,
  StyledTitle,
  ButtonContainer,
  StyledMenuItem,
} from "./Edit.style";
import DrawerCM from "components/shared/Drawer";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { articleSchema, validateImg } from "validations";
import ReactHookFormSelect from "components/shared/ReactHookFormSelect";
import {
  deleteArticleRequest,
  getArticleInfoRequest,
  updateArticleRequest,
  getCategoryNewsRequest,
} from "api/requests";
import { useNavigate, useParams } from "react-router-dom";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import Toast from "helper/toast";
import DeleteModal from "components/shared/Modal/Delete";
import ProgressBarCM from "components/shared/ProgressBar";
import Editor, { buttonList } from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
let initialPage = 1;
export default function EditNews() {
  const params = useParams();
  const navigate = useNavigate();
  const [frame, setFrame] = useState({ data: [], count: 0 });
  const [page, setPage] = useState(initialPage);
  const { request, loading, isUploading, setUploadProgress, uploadProgress } =
    useHttp();
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(articleSchema),
  });
  const [image, setImage] = useState({ url: null, isWeb: false });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [file, setFile] = useState("");

  ////// editor ////////
  const [content, setContent] = useState("");
  const handleChange = (content) => {
    setContent(content);
  };

  const handelTempChange = (e) => {
    setValue("text", e);
  };


  const handelShowModal = () => setShowDeleteModal((state) => !state);

  const onDelete = async () => {
    const res = await request({
      url: deleteArticleRequest,
      values: params.articleId,
    });

    if (res) {
      Toast({ type: "success", title: "حذف مقاله" });
      navigate("/news");
    }
  };

  const onSubmit = async (data) => {
    const res = await request({
      url: () =>
        updateArticleRequest(
          { id: params.articleId, ...data, content },
          (progress) => setUploadProgress(progress)
        ),
      // isFile: true,
    });

    if (res) Toast({ type: "success", title: "ویرایش مقاله" });
  };

  // const handleChangeImage = (val) => {
  //   validateImg(val);
  //   setImage({ url: val, isChanged: true });
  // };

  const getArticle = useCallback(async () => {
    let res = await request({
      url: getArticleInfoRequest,
      values: params.articleId,
    });

    if (res) {
      reset({
        id: res.id,
        title: res.title,
        text: res.text,
        article_category_id: res.article_category_id,
      });
      // setFile({ url: res.file });
      setContent(res.text);
    }
  }, [request, params.articleId, reset]);

  const getFrame = useCallback(async () => {
    const res = await request({
      url: getCategoryNewsRequest,
      values: { skip: (page - 1) * 50, limit: 50 },
    });

    if (res) {
      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items.title,
      }));

      setFrame({ data: transformedData, count: res.count });
    }
  }, [request]);

  useEffect(() => {
    getArticle();
    getFrame();
  }, [getArticle, page, getFrame]);

  return (
    <DrawerCM title="ویرایش مقاله">
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container my={2}>
            <Grid item mt={3} xs={12}>
              <BackButton />
            </Grid>
            <StyledStack>
              <StyledTitle>ویرایش مقاله</StyledTitle>
              <Grid container>
                <Grid item md={12} xs={12} p={1.5}>
                  <TextField
                    label="عنوان"
                    variant="outlined"
                    fullWidth
                    id="title"
                    {...register("title")}
                    error={Boolean(errors.title)}
                    helpertext={errors.title?.message}
                  />
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <ReactHookFormSelect
                    id="article_category_id"
                    label="سردسته"
                    control={control}
                    // defaultValue={}
                    title="سردسته"
                    onChange={handelTempChange}
                  >
                    {frame.data.map((row, index) => (
                      <StyledMenuItem value={row.id} key={"option" + index}>
                        {row.title}
                      </StyledMenuItem>
                    ))}
                  </ReactHookFormSelect>
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <TextField
                    // label="متن"
                    type="file"
                    variant="outlined"
                    fullWidth
                    id="file"
                    // value={file.url}
                    {...register("file")}
                    error={Boolean(errors.file)}
                    helpertext={errors.file?.message}
                    onChange={(e) => setFile(e.target.files[0].name)}
                  />
                </Grid>

                <Grid item md={12} xs={12} p={1.2}>
                  {/* <TextField
                    label="متن"
                    variant="outlined"
                    multiline
                    rows={5.7}
                    fullWidth
                    id="text"
                    {...register("text")}
                    error={Boolean(errors.text)}
                    helpertext={errors.text?.message}
                  /> */}
                  {content && (
                    <Editor
                      enableToolbar={true}
                      onChange={handleChange}
                      defaultValue={content}
                      setDefaultStyle="font-family: IranSans; height: 40vh;"
                      setOptions={{
                        buttonList: buttonList.complex,
                        font: [
                          "IranSans",
                          "IranSansBold",
                          "Arial",
                          "Impact",
                          "Tahoma",
                        ],
                      }}
                    />
                  )}
                </Grid>

                {/* <Grid item md={6} xs={12} p={1.5}>
                  {image.url && (
                    <Upload
                      refillable
                      type="edit-news"
                      isWeb={image.isWeb}
                      onChange={handleChangeImage}
                      file={image.url}
                      isLocal={!image.isWeb}
                      width={"100%"}
                      height={"100%"}
                    />
                  )}
                </Grid> */}

                <ButtonContainer>
                  <Button
                    color="error"
                    startIcon={<DeleteIcon />}
                    variant="contained"
                    sx={{ mt: 1, mr: 1 }}
                    onClick={handelShowModal}
                  >
                    حذف
                  </Button>
                  <Button
                    color="success"
                    startIcon={<CheckIcon />}
                    variant="contained"
                    sx={{ mt: 1, mr: 1 }}
                    onClick={handleSubmit(onSubmit)}
                  >
                    ذخیره
                  </Button>
                </ButtonContainer>
              </Grid>
            </StyledStack>
          </Grid>
          <DeleteModal
            show={showDeleteModal}
            onClose={handelShowModal}
            onDelete={onDelete}
          />
        </Fragment>
      )}
    </DrawerCM>
  );
}
